import { useEffect, useState } from "react";
import Header from "../Components/Header/Header";
import Footer from "../Components/Footer/Footer";
import { businessPages } from "../actions/ApiCalls";
import './app.css';
import {IMAGE_URL} from "../path";

function OurStory() {
    const [data, setData] = useState<any[]>([]);
    const [isMobile, setIsMobile] = useState<boolean>(false);
    const publicUrl = IMAGE_URL;

    useEffect(() => {
        document.title = "Vinimark | Our Story";

        const handleResize = () => {
            setIsMobile(window.innerWidth <= 575);
        };

        handleResize();
        window.addEventListener("resize", handleResize);

        businessPages(1)
            .then(response => {
                setData(response.data);
            })
            .catch(error => {
                console.error("Failed to fetch business pages:", error);
            });

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // Find the last index of a text-only section (no image)
    const lastTextIndex = [...data]
        .reverse()
        .findIndex(page => !page.image);
    const trueLastTextIndex = lastTextIndex >= 0 ? data.length - 1 - lastTextIndex : -1;

    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            marginTop: window.innerWidth <= 575 ? '70px' : '140px'
        }}>
            <Header />
            <div className="our-story-container" style={{ flex: '1' }}>
                {data.map((page, index) => {
                    const isLastTextSection = index === trueLastTextIndex;

                    return (
                        <div key={index}>
                            {page.image ? (
                                <img
                                    src={`${publicUrl}/${isMobile ? page.mobile_image : page.image}`}
                                    alt={page.title || "Business Page"}
                                    className={page.is_full ? "our-story-image-full" : "our-story-image-centered"}
                                />
                            ) : (
                                <div className={`our-story-text-section-wrapper` }>
                                    <div className={`our-story-text-section ${isMobile ? "mobile" : ""}`} >
                                        <div className="our-story-text-block-left" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', alignContent: 'flex-start' , width: '100%', marginBottom: '20px'}}>

                                            <div style={{
                                                width: window.innerWidth <= 575 ? '100%' : '70%',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                justifyContent: 'flex-start',
                                                alignItems: window.innerWidth <= 575 ? 'flex-start' : 'flex-end',
                                                padding: 0,
                                                margin: 0,


                                            }}>
                                                <div
                                                    style={{
                                                      fontSize: '20px',
                                                      textAlign: window.innerWidth <= 575 ? 'left' : 'right',
                                                      width: '100%',
                                                      marginRight: window.innerWidth <= 575 ? 0 : '72px',
                                                      marginTop: 0,
                                                      padding: 0,

                                                    }}
                                                    dangerouslySetInnerHTML={{
                                                        __html: (page.left_text || "").replace(/<p>/g, '<p style="margin-top: 0; font-weight: 300; font-size: 13px">')
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        <div className="our-story-text-block">
                                            <div
                                                style={{
                                                    width: window.innerWidth <= 575 ? '90%' : '70%',
                                                    marginTop: 0,
                                                    marginLeft: isMobile ? '0px' : '24px',
                                                }}
                                                dangerouslySetInnerHTML={{
                                                    __html: ((): any => {
                                                        const rightText = page.right_text || '';
                                                        const styledRightText = rightText.replace(/<p>/g, '<p style="font-weight: 400; margin-top: 0; font-size: 13px">');
                                                        return `${page.title ? `<h2 class="our-story-title" style="font-weight: 600">${page.title}</h2>` : ''}${styledRightText}`;
                                                    })()
                                                }}
                                            />
                                            {isLastTextSection && (
                                                <div style={{ marginBottom: '30px', marginLeft: isMobile ? '0px' : '24px' }} className="read-more">
                                                    <p style={{fontSize: '13px', lineHeight: '16.9px'}}>READ ON: <a style={{lineHeight: '16.9px', fontSize: '13px'}} href={'/about/vision'}>VISION</a></p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
            <Footer />
        </div>
    );
}

export default OurStory;
